import { createFileRoute } from '@tanstack/react-router';
import { BibleReader } from '@/components/BibleReader/BibleReader';
import { isValidBookId } from '@/lib/books';

export const Route = createFileRoute('/read/$book/$chapter')({
  component: ReadRoute,
});

function ReadRoute() {
  const { book, chapter } = Route.useParams();
  if (!isValidBookId(book.toUpperCase())) {
    return (
      <main>
        <p className="muted">Unknown book: {book}</p>
      </main>
    );
  }
  const c = parseInt(chapter, 10);
  if (!Number.isFinite(c) || c < 1) {
    return (
      <main>
        <p className="muted">Unknown chapter.</p>
      </main>
    );
  }
  return <BibleReader book={book.toUpperCase() as never} chapter={c} />;
}
